if (!customElements.get('video-slider')) {
  customElements.define(
    'video-slider',
    class VideoSlider extends HTMLElement {
      constructor() {
        super();

        this.sectionId = this.dataset.sectionId;
        this.section = this.closest(`.section-${this.sectionId}`);
        this.sliderControls = this.section ? this.section.querySelector('.swiper-controls') : null;
        this.sliderInstance = false;

        this.itemsMobile = parseFloat(this.dataset.itemsMobile) || 1;
        this.itemsTablet = parseFloat(this.dataset.itemsTablet) || this.itemsMobile;
        this.itemsDesktop = parseFloat(this.dataset.itemsDesktop) || this.itemsTablet;
        this.showArrows = this.dataset.showArrows === 'true';
        this.showPagination = this.dataset.showPagination === 'true';
        this.loop = this.dataset.loop === 'true';

        this.initSlider();
      }

      initSlider() {
        const additionalModules = [FoxTheme.Swiper.Autoplay];

        this.sliderOptions = {
          slidesPerView: this.itemsMobile,
          spaceBetween: 16,
          watchOverflow: true,
          grabCursor: true,
          allowTouchMove: true,
          threshold: 2,
          loop: this.loop,
          breakpoints: {
            768: {
              slidesPerView: this.itemsTablet,
            },
            1024: {
              slidesPerView: this.itemsDesktop,
            },
          },
          on: {
            init: this.handleAfterInit.bind(this),
          },
        };

        if (this.showArrows && this.sliderControls) {
          this.sliderOptions.navigation = {
            nextEl: this.sliderControls.querySelector('.swiper-button-next'),
            prevEl: this.sliderControls.querySelector('.swiper-button-prev'),
          };
        }

        if (this.showPagination && this.sliderControls) {
          this.sliderOptions.pagination = {
            el: this.sliderControls.querySelector('.swiper-pagination'),
            clickable: true,
          };
        }

        const autoplayDelay = parseInt(this.dataset.autoplay);
        if (autoplayDelay > 0) {
          this.sliderOptions.autoplay = {
            delay: autoplayDelay,
            disableOnInteraction: false,
          };
        }

        this.sliderInstance = new window.FoxTheme.Carousel(this, this.sliderOptions, additionalModules);
        this.sliderInstance.init();

        if (Shopify.designMode && typeof this.sliderInstance === 'object') {
          document.addEventListener('shopify:block:select', (event) => {
            if (!this.section || event.detail.sectionId != this.sectionId) return;
            const index = Number(event.target.dataset.index);
            if (this.loop) {
              this.sliderInstance.slider.slideToLoop(index);
            } else {
              this.sliderInstance.slider.slideTo(index);
            }
          });
        }
      }

      handleAfterInit() {
        if (this.sliderControls) {
          const activeBullet = this.sliderControls.querySelector('.swiper-pagination-bullet-active');

          if (activeBullet) {
            activeBullet.classList.remove('swiper-pagination-bullet-active');
            activeBullet.offsetHeight; // Trigger reflow.
            activeBullet.classList.add('swiper-pagination-bullet-active');
          }
        }
      }
    }
  );
}
